import { Action } from '@ngrx/store';
import { appState } from 'src/app/models/data-model';
import { assign, drop, find, cloneDeep } from 'lodash';

// Question Blocks
export const UPDATE_CONTENT = 'UPDATE_CONTENT';
export const RESET_CONTENT = 'RESET_CONTENT';
export const UPDATE_CONDITIONAL_BLOCK = 'UPDATE_CONDITIONAL_BLOCK';

// Miscellaneous
export const UPDATE_TOTAL_ALLOCATION = 'UPDATE_TOTAL_ALLOCATION';                         // Beneficiary % Total Allocation
export const UPDATE_PATH = 'UPDATE_PATH';                                                 // Track previous blocks/paths
export const ADD_QUESTIONS = 'ADD_QUESTIONS';
export const ADD_APP_ID = 'ADD_APP_ID';
// export const ADD_AGENT_ID = 'ADD_AGENT_ID'; <- deprecated due to having no functionality
export const ADD_APPLICATION_ID = 'ADD_APPLICATION_ID';
export const COMPLETED = 'COMPLETED';
export const QUEUE_UPDATE = 'QUEUE_UPDATE';
export const QUEUE_REMOVE = 'QUEUE_REMOVE';
export const UPDATE_ACTIVE_SUBMISSION = 'UPDATE_ACTIVE_SUBMISSION';
export const UPDATE_PAYMENT_DETAILS = 'UPDATE_PAYMENT_DETAILS';
export const UPDATE_SIMULATE = 'UPDATE_SIMULATE';
export const UPDATE_DECISION_INFO = 'UPDATE_DECISION_INFO';
export const RESET_DECISION_INFO = 'RESET_DECISION_INFO';

// Added by Ross for intake
export const UPDATE_PAYLOAD = 'UPDATE_PAYLOAD';
export const UPDATE_LEAD = 'UPDATE_LEAD';
export const UPDATE_SFTOKEN = 'UPDATE_SFTOKEN';
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
export const UPDATE_EAPP_ID = 'UPDATE_EAPP_ID';
export const UPDATE_PERSONA = 'UPDATE_PERSONA';
export const UPDATE_AGENT = 'UPDATE_AGENT';
export const UPDATE_EXPIRED = 'UPDATE_EXPIRED';

export interface AppState {
	sections: any;
}

export function appReducer(state: any = appState, action: Action) {
	switch (action.type) {
		case COMPLETED:
			return { ...state, completed: true };
		case UPDATE_EXPIRED:
			return { ...state, expired: action['payload'] };
		case UPDATE_CONTENT:
			const updatedContent = { ...cloneDeep(state.content), ...action['payload'] };
			return { ...state, content: updatedContent };
		case RESET_CONTENT:
			return { ...state, content: appState.content };
		case UPDATE_CONDITIONAL_BLOCK:
			return { ...state, content: { ...state.content, ConditionalBlock: action['payload'] } };
		case UPDATE_PATH:
			const prev = find(state.path, { url: window.location.pathname });
			if (!prev) {
				return { ...state, path: action['payload'] };
			}
		case UPDATE_TOTAL_ALLOCATION:
			return { ...state, totalAllocation: action['payload'] };
		case ADD_QUESTIONS:
			return { ...state, questions: action['payload'] };
		case ADD_APP_ID:
			return { ...state, appAuthId: action['payload'] };
		case ADD_APPLICATION_ID:
			return { ...state, appId: action['payload'] };
		case UPDATE_AGENT:
			return { ...state, agentData: action['payload'] };
		case UPDATE_PAYLOAD:
			const originalPayload = state.payload || {};
			const updatedPayload = assign({}, originalPayload, action['payload']);
			return { ...state, payload: updatedPayload };
		case UPDATE_LEAD:
			const originalLead = state.leadDetails || {};
			const updatedLead = assign({}, originalLead, action['payload']);
			return { ...state, leadDetails: updatedLead };
		case UPDATE_SFTOKEN:
			return { ...state, sfToken: action['payload'] };
		case UPDATE_FORM_DATA:
			return { ...state, formData: action['payload'] };
		case UPDATE_EAPP_ID:
			return { ...state, eAppId: action['payload'] };
		case QUEUE_UPDATE:
			return { ...state, payloadQueue: [...state.payloadQueue, action['payload']] };
		case QUEUE_REMOVE:
			return { ...state, payloadQueue: [...drop(state.payloadQueue)] };
		case UPDATE_ACTIVE_SUBMISSION:
			return { ...state, activeSubmission: action['payload'] };
		case UPDATE_SIMULATE:
			return { ...state, simulate: action['payload'] };
		case UPDATE_PERSONA:
			const updatedPersona: any = { ...state.userRole, ...action['payload'] };
			return { ...state, userRole: updatedPersona };
		case UPDATE_DECISION_INFO:
			return { ...state, decisionInfo: action['payload'] };
		case RESET_DECISION_INFO:
			return { ...state, decisionInfo: null };
		default:
			return state;
	}
}
